import React, {useState} from "react";
import {Modal} from "flowbite-react";


interface DefaultModalProps {
    title: string;
    content: React.ReactNode; // React.ReactNode represents the JSX/React elements
    label: string;
}

export default function DefaultModal({label, title, content}: DefaultModalProps) {
    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <span onClick={() => setOpenModal(true)}
               className="p-2 font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer">
                {label}
            </span>
            <Modal show={openModal} onClose={() => setOpenModal(false)}>
                <Modal.Header>{title}</Modal.Header>
                <Modal.Body>{content}</Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal>
        </>
    );
}
